import { isDefined } from '@/utils/isDefined';

const wait = (t: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, t);
  });

export enum PollingState {
  RUNNING = 'RUNNING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export const poll = <T>(request: () => Promise<T | null>, check: (val: T) => PollingState) => {
  let retry = 0;
  const pollRequest = (): Promise<T> =>
    request().then((value) => {
      if (isDefined(value)) {
        const state = check(value);

        switch (state) {
          case PollingState.SUCCESS:
            return value;
          case PollingState.FAILED:
            return Promise.reject(value);
        }
      }

      if (retry > 60) {
        throw new Error('too many retries');
      }

      retry += 1;
      return wait(1000).then(() => pollRequest());
    });
  return pollRequest();
};
